import { render } from "./UserBankPopup.vue?vue&type=template&id=b0a4a288"
import script from "./UserBankPopup.vue?vue&type=script&lang=js"
export * from "./UserBankPopup.vue?vue&type=script&lang=js"

import "./UserBankPopup.vue?vue&type=style&index=0&id=b0a4a288&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__